<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

import {
  buildDlqStatusOptions,
  buildReviewActions,
} from './utils/automationOperationsConstants';

defineProps({
  selectedCount: { type: Number, default: 0 },
  canOperate: { type: Boolean, default: false },
  isBulkLoading: { type: Boolean, default: false },
});

defineEmits(['statusChange', 'bulkTransition']);

const statusFilter = defineModel('statusFilter', {
  type: String,
  required: true,
});
const bulkReason = defineModel('bulkReason', {
  type: String,
  required: true,
});

const { t } = useI18n();

const statusOptions = computed(() => buildDlqStatusOptions(t));
const reviewActions = computed(() => buildReviewActions(t));
</script>

<template>
  <div
    class="mb-3 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between"
  >
    <div class="flex flex-wrap items-end gap-3">
      <label class="flex flex-col gap-1">
        <span class="text-label-small text-n-slate-11">
          {{ $t('AUTOMATION.OPERATIONS.DLQ.FILTER') }}
        </span>
        <select
          v-model="statusFilter"
          data-test="automation-dlq-status-filter"
          class="h-8 min-w-44 rounded-md border border-n-weak bg-n-surface-1 px-2 text-body-main text-n-slate-12"
          @change="$emit('statusChange')"
        >
          <option
            v-for="option in statusOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </label>
      <label class="flex min-w-64 flex-1 flex-col gap-1">
        <span class="text-label-small text-n-slate-11">
          {{ $t('AUTOMATION.OPERATIONS.DLQ.BULK_REASON') }}
        </span>
        <input
          v-model="bulkReason"
          type="text"
          class="h-8 rounded-md border border-n-weak bg-n-surface-1 px-2 text-body-main text-n-slate-12"
          :placeholder="$t('AUTOMATION.OPERATIONS.DLQ.REASON_PLACEHOLDER')"
        />
      </label>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <span class="text-body-main text-n-slate-11">
        {{
          $t('AUTOMATION.OPERATIONS.DLQ.SELECTED', {
            count: selectedCount,
          })
        }}
      </span>
      <Button
        v-for="action in reviewActions"
        :key="action.name"
        :label="action.label"
        :icon="action.icon"
        :color="action.color"
        variant="outline"
        size="sm"
        :is-loading="isBulkLoading"
        :disabled="!canOperate || !selectedCount || bulkReason.trim().length < 8"
        @click="$emit('bulkTransition', action.name)"
      />
    </div>
  </div>
</template>
